export default "__VITE_ASSET__60163f9d__"